module.exports = __webpack_public_path__ + "static/media/apple-app-store.17f55d2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/apple-app-store.svg
// module id = 1910
// module chunks = 0